<div class="main">
  <div class="device-logo web-logo">
    <app-logo></app-logo>
  </div>
  <div class="custom-wrapper">
    <div id="header_section" class="header-section d-flex">
      <div id="back_icon_mob">
        <img
          pointer
          (click)="navigateBack(false)"
          imageName="back-arrow.png"
          [common]="true"
          alt="Back"
        />
      </div>
    </div>

    <section class="login-content" id="content">
      <div class="signup-header">
        <h2 id="main_header_text" class="login-main-header mb-0">Forgot Username</h2>
      </div>

      <div class="login-content-wrapper">
        @if (isError()) {
          <div class="error-message">
            <p class="text-danger title-12">
              This email is not the registered email in your profile. Please contact the customer
              support at
              @if (getTechnicalSupportNumber() | async; as technicalSupportNumber) {
                <span>
                  {{ technicalSupportNumber }}
                </span>
              }
              or try again with your registered email address.
            </p>
          </div>
        }
        @if (isSuccess()) {
          <div class="success-mesg">
            <p>
              We have successfully emailed the username to your registered email address. Please try
              logging in with that username.
            </p>
            <div class="buttons">
              <button
                mat-raised-button
                type="submit"
                class="primary-button uppercase"
                (click)="navigateBack(true)"
              >
                Ok
              </button>
            </div>
          </div>
        }
        @if (!isSuccess()) {
          <div class="form-content">
            <div class="form-group">
              <label for="email">
                Registered Email Address
                <span class="input-required-on-dark-bg text-w-600">*</span>
              </label>
              @if (emailControl.touched && emailControl.errors?.pattern) {
                <span class="text-danger">Please enter a valid email address.</span>
              }
              @if (emailControl.touched && emailControl.errors?.required) {
                <span class="text-danger">Please enter an email address.</span>
              }
              <input
                id="email"
                [formControl]="emailControl"
                type="text"
                name="Registered Email"
                class="form-control"
              />
            </div>
            @if (isLoading()) {
              <div class="loader">
                <img imageName="horizontal-loader.gif" [common]="true" alt="Loader" />
              </div>
            }
          </div>
        }
        @if (!isSuccess()) {
          <div class="buttons">
            <button
              id="next_step_btn"
              (click)="sendMail()"
              [disabled]="emailControl.invalid"
              mat-raised-button
              type="submit"
              class="primary-button uppercase"
            >
              Submit
            </button>
          </div>
        }
      </div>
    </section>
  </div>
</div>
